import React, { useMemo } from 'react';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import useFetchFeatures from "../../../hocs/useFetchFeatures";
import SQFTFeaturesHeader from "../menu/cabinet/toolMenu/commonParts/SQFTFeaturesHeader";
import LoadingSpinner from "../../../../ui/loadingSpinner";
import FeaturesGrid from "../menu/commonTools/featuresGrid/FeaturesGrid";
import { setSelectedFeatureInPicker } from "../../../../../actions/sqftMenuFunctions";

const SqftRightFeaturesGrid = (props) => {
  const {
    isMobile,
    windowHeight,
    groheFiltersSearchText,
    selectedFilters,
    featurePicker,
    setSelectedFeatureInPicker
  } = props;

  // 1.) Enter featureGroup part id that you want it to be displayed here
  const expanded = featurePicker.isOpen;
  const partIds = useMemo(() => featurePicker.partIds, [featurePicker]);
  const searchText = useMemo(() => expanded ? groheFiltersSearchText : '', [groheFiltersSearchText, expanded]);

  // we will get features only with thirdPartyAR3DUrls
  const shouldGetModelsOnlyWithThirdPartyAR3DUrls = false;

  const { featuresData, isLoading } = useFetchFeatures(partIds, searchText, shouldGetModelsOnlyWithThirdPartyAR3DUrls, selectedFilters);
  const hasMultiplePartIds = partIds.length > 1;

  return (
    <div className={"content content--right side-level2--right" + (expanded ? " expanded" : "")}>
      <div className={"side-level2__inner"}>
        <div className="side-level2__header-sticky">
          <SQFTFeaturesHeader headerTitle={" "} partId={partIds[0]} />
        </div>
        <div className="side-level2__inner-withsidebar">
          {partIds.map((partId) => {
            const featureData = featuresData[partId];

            // 2.) Enter feature click functionality here
            const itemClickCallback = (e, feature, parentFeature) => {
              void e;
              void feature;
              void parentFeature;
              setSelectedFeatureInPicker(feature.dbFeature.id);
            };

            const defaultActiveFeatureIndex = featureData && featureData.rows
              ? featureData.rows.findIndex(row => row.part.dbFeature.sharedFeatureName === featurePicker.sharedFeatureName)
              : 0;

            return (
              <React.Fragment key={partId}>
                {isLoading ? (
                  <LoadingSpinner />
                ) : (
                  featureData && (
                    <FeaturesGrid
                      partId={partId}
                      rows={featureData.rows}
                      defaultActiveFeatureIndex={defaultActiveFeatureIndex}
                      featureGroup={featureData.featureGroup}
                      isMobile={isMobile}
                      windowHeight={windowHeight}
                      itemClickCallback={itemClickCallback}
                      shouldShowFullHeight={hasMultiplePartIds}
                    />
                  )
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (store) => {
  const { menuOpened } = store.sqftMenuState;
  const { featurePicker } = store.sqftMenuState;
  const { isMobile, windowHeight } = store.serverState;
  const { groheFiltersSearchText } = store.groheState;
  const { selectedFilters } = store.filterState;

  return {
    menuOpened,
    isMobile,
    windowHeight,
    groheFiltersSearchText,
    selectedFilters, // re-render on change
    featurePicker,
  };
};

const mapDispatchToProps = {
  setSelectedFeatureInPicker
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftRightFeaturesGrid)
);
